import React from 'react';
import {ProgressPortrait, ProgressPortraitClientProfileListColumn, ProgressPortraitFileType} from "./domain";
import {ProgressPortraitDownloadLink} from "./ProgressPortraitDownloadLink";
import {formatDateStr} from "../../../common/util/date";

type Props = {
    portrait: ProgressPortrait;
    isSelected: boolean;
    onClick: () => void;
}

export const formatProviderProgressPortraitFileName = (fileName: string) =>
    fileName.replace(/^progress[-_]portrait[-_]provider[-_]/i, '');

export const ProgressPortraitPreview = ({portrait, isSelected, onClick}: Props) => {
    const rowClass = isSelected
        ? 'bg-blue-50'
        : 'bg-white hover:bg-gray-50';

    const renderCell = (column: typeof ProgressPortraitClientProfileListColumn[number]) => {
        if (column.attr === 'reportDate') {
            return portrait.reportDate ? formatDateStr(portrait.reportDate) : '—';
        }
        if (column.attr === 'caseNumber') {
            return portrait.caseNumber ?? '—';
        }
        if (column.attr === 'hasProviderProgressPortrait') {
            return portrait.hasProviderProgressPortrait
                ? <ProgressPortraitDownloadLink
                    portraitGuid={portrait.guid}
                    fileType={ProgressPortraitFileType.PROVIDER}
                    label={portrait.providerProgressPortraitFileName
                        ? formatProviderProgressPortraitFileName(portrait.providerProgressPortraitFileName) || 'Download'
                        : 'Download'}
                />
                : '—';
        }
        
        return null;
    };

    return (
        <tr
            key={portrait.guid}
            className={`text-sm text-gray-700 border-b border-gray-100 cursor-pointer ${rowClass}`}
            onClick={onClick}
        >
            {ProgressPortraitClientProfileListColumn.map((column, index) => (
                <td key={column.attr} className={`py-3 ${index === 0 ? 'pl-8' : ''}`}>
                    {renderCell(column)}
                </td>
            ))}
        </tr>
    );
};
